import { __assign, __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
var dots = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "5", height: size || "15" }, props),
        React.createElement("g", { fill: "none", "fill-rule": "evenodd" },
            React.createElement("g", { fill: "#FFF" },
                React.createElement("path", { d: "M645.595 375c-1.094-.041-1.952-.954-1.924-2.05.027-1.094.929-1.963 2.024-1.95 1.094.014 1.975.905 1.975 2-.021 1.125-.95 2.02-2.075 2zm0-7c-1.094-.041-1.952-.954-1.924-2.05.027-1.094.929-1.963 2.024-1.95 1.094.014 1.975.905 1.975 2-.021 1.125-.95 2.02-2.075 2zm.15 10c1.094.041 1.952.954 1.924 2.05-.027 1.094-.929 1.963-2.024 1.95-1.094-.014-1.975-.905-1.975-2 .023-1.124.95-2.018 2.075-2z", transform: "translate(-643 -364)" })))));
};
dots.displayName = 'love_empty';
dots.propTypes = {
    size: PropTypes.string
};
export default dots;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=dots.js.map